import React, { useState } from "react";
import { motion } from "framer-motion";
import { Wallet, Percent, Truck, Sparkles, ArrowRight } from "lucide-react";
import { startCheckout } from "../lib/checkout";
import { TIERS } from "../data/tiers";
import { TAP, fadeUp } from "../lib/motion";

const NODES = [
  { icon: Wallet, label: "$199 MEMBERSHIP" },
  { icon: Wallet, label: "$250 MONTHLY CREDIT" },
  { icon: Percent, label: "30% MEMBER PRICING" },
  { icon: Truck, label: "FREE SHIPPING" },
  { icon: Sparkles, label: "PEPTIQ PREMIUM" },
];

export const WhyPro = () => {
  const [loading, setLoading] = useState(false);
  return (
    <section className="relative py-20 sm:py-28 bg-[#0A0D10] border-y border-[var(--border)]" data-testid="why-pro">
      <div className="max-w-6xl mx-auto px-5">
        <motion.p className="eyebrow text-cyan text-center mb-14" {...fadeUp()}>
          Why Members Choose Pro
        </motion.p>

        <div className="flex flex-col md:flex-row items-stretch md:items-center justify-between gap-4 md:gap-2">
          {NODES.map((n, i) => (
            <React.Fragment key={n.label}>
              <motion.div
                className="flex-1 flex flex-col items-center text-center gap-3 py-6 px-3 glass"
                {...fadeUp(i * 0.08)}
              >
                <n.icon size={22} className="text-cyan" strokeWidth={1.5} />
                <span className="font-display text-xs sm:text-sm font-600 tracking-wide text-white leading-tight">{n.label}</span>
              </motion.div>
              {i < NODES.length - 1 && (
                <ArrowRight size={18} className="text-emerald mx-auto md:mx-0 rotate-90 md:rotate-0 shrink-0" />
              )}
            </React.Fragment>
          ))}
        </div>

        <motion.h3
          className="mt-16 text-center font-display text-2xl sm:text-4xl font-700 tracking-tight text-white max-w-3xl mx-auto leading-tight"
          {...fadeUp()}
        >
          MORE VALUE. MORE ACCESS.{" "}
          <span className="bg-gradient-to-r from-[#00D4FF] to-[#00E676] bg-clip-text text-transparent">MORE REASON TO OPTIMIZE.</span>
        </motion.h3>

        <div className="mt-10 flex justify-center">
          <motion.button
            whileTap={TAP}
            onClick={() => startCheckout(TIERS.pro.lookupKey, setLoading)}
            disabled={loading}
            className="cta-primary px-10 py-4 text-sm disabled:opacity-60"
            data-testid="why-pro-cta"
          >
            {loading ? "REDIRECTING…" : "CHOOSE PRO — $199/MONTH"}
          </motion.button>
        </div>
      </div>
    </section>
  );
};
